
            const data = {"name":"ic_radio_select","data":{"width":"20","height":"20","viewBox":"0 0 20 20","data":"<circle pid=\"0\" cx=\"10\" cy=\"10\" r=\"9.5\" _stroke=\"#00CF3A\"/><circle pid=\"1\" cx=\"10\" cy=\"10\" r=\"6\" _fill=\"#00CF3A\"/>","originalColors":[{"type":"stroke","color":"#00CF3A"},{"type":"fill","color":"#00CF3A"}],"stopColors":[]}}
        
                module.exports = data
                